export const tovIconNames = [
  'archive',
  'arrow-clockwise',
  'arrow-counter-clockwise',
  'arrow-left',
  'arrow-right',
  'arrow-square-out',
  'arrows-clockwise',
  'book-open',
  'books',
  'calendar-blank',
  'cards',
  'chart-bar',
  'chat-centered-text',
  'check',
  'checks',
  'clock',
  'copy',
  'caret-right',
  'caret-left',
  'caret-up',
  'caret-down',
  'database',
  'desktop',
  'device-mobile-camera',
  'dot-outline',
  'dots-six-vertical',
  'caret-double-left',
  'caret-double-right',
  'envelope-simple',
  'eye',
  'eye-slash',
  'faders',
  'file-text',
  'floppy-disk',
  'folder-open',
  'folders',
  'gear-six',
  'gift',
  'globe',
  'house',
  'heart',
  'image',
  'images',
  'tray',
  'key',
  'lifebuoy',
  'link',
  'list',
  'list-checks',
  'lock',
  'magnifying-glass',
  'map-pin',
  'megaphone',
  'monitor-play',
  'minus',
  'newspaper',
  'palette',
  'pencil-simple',
  'plugs-connected',
  'plus',
  'corners-out',
  'question',
  'sparkle',
  'scroll',
  'shield',
  'shopping-bag-open',
  'sign-in',
  'squares-four',
  'table',
  'trash',
  'tree-structure',
  'toggle-right',
  'upload',
  'user',
  'user-plus',
  'users',
  'users-three',
  'warning-circle',
  'wrench',
  'x',
  'dots-three-vertical',
] as const;

export type TovIconName = (typeof tovIconNames)[number];

export function getTovIconClass(name: TovIconName) {
  return `ph ph-${name}`;
}
